<template>
  <div class="animated fadeIn">
    <b-input-group class="mb-3">
      <template #append>
        <b-input-group-text>
          <i class="fa fa-search" />
        </b-input-group-text>
      </template>
      <b-form-input
        v-model.trim="search_input"
        debounce="500"
        type="text"
        placeholder="Instrument Name"
      />
    </b-input-group>
    <b-alert
      v-if="!search_input && !instrument_collection.length"
      show
      class="py-2"
    >
      <i class="fa fa-exclamation-circle" /> Use the search box, above, to find
      and select an instrument instance to begin running.
    </b-alert>
    <div v-if="loading" class="text-center my-4 font-2xl text-muted">
      <i class="fal fa-spinner fa-spin" /> Instrument Data Loading...
    </div>
    <template v-else>
      <b-form-group label="Jig" label-cols="2">
        <multiselect
          v-model="jig"
          :options="instrument_jig_collection"
          :multiple="false"
          track-by="id"
          label="name"
        />
      </b-form-group>
      <template v-if="instrument_collection.length">
        <custom-table-pagination
          :options="per_page_options"
          :current_page="current_page"
          :per_page="per_page"
          :total_rows="total_rows"
          @update="updatePaginationData"
        />
        <div v-for="(instrument, index) in instrument_collection" :key="index">
          <h3>{{ instrument.name }}</h3>
          <b-row class="pr-3">
            <b-col
              v-for="(
                instance, instrument_index
              ) in instrument.instrument_instances"
              :key="instrument_index"
              cols="4"
              class="mb-3 pr-0"
              @click="pickInstance(instance)"
            >
              <b-card
                no-body
                :class="`${
                  selected_instances.find(({ id }) => id === instance.id)
                    ? 'picked'
                    : ''
                } p-2 mb-0 pointer`"
              >
                <div>{{ instance.identifier }}</div>
                <div>{{ instrument.name }}</div>
                <!-- <instrument-capacity-bar
                  class="d-inline-block w-100"
                  :instrument_instance="instance"
                  :process="schedule_process"
                /> -->
              </b-card>
            </b-col>
          </b-row>
        </div>
      </template>
      <b-alert
        v-if="search_input && !instrument_collection.length"
        show
        class="py-1 m-0"
      >
        <i class="fa fa-exclamation-circle" /> No matches found.
      </b-alert>
    </template>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import InstrumentCapacityBar from "@/components/lab/instrument/InstrumentCapacityBar";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const InstrumentRepository = LabRepositoryFactory.get("instrument");
const InstrumentJigRepository = LabRepositoryFactory.get("instrumentJig");

export default {
  name: "InstrumentRunnerSearch",
  components: {
    CustomTablePagination,
    InstrumentCapacityBar,
    Multiselect,
  },
  props: {
    selected_instances: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      search: null,
      instrument_collection: [],
      instrument_jig_collection: [],
      jig: null,
      current_page: 1,
      per_page: 10,
      total_rows: 10,
      per_page_options: [10, 15, 20],
    };
  },
  computed: {
    search_input: {
      get() {
        return this.search;
      },
      set(value) {
        value && this.fetchCollection(value);
        this.search = value;
      },
    },
  },
  methods: {
    pickInstance(instance) {
      this.$emit("updateSelectedInstances", instance);
    },
    updatePaginationData({ field, value }) {
      this[field] = value;
      field === "per_page" && (this.current_page = 1);
      this.fetchCollection();
    },
    async fetchCollection(value = this.search) {
      this.loading = true;

      const { per_page, current_page } = this;
      const { data } = await InstrumentRepository.getSome({
        connections: ["instrumentInstances.instrument"],
        filters: [
          {
            field: "name",
            operator: "ct",
            value: [value],
          },
        ],
        sort: [
          {
            field: "name",
            value: "ASC",
          },
        ],
        limit: per_page,
        page: current_page,
      });
      this.total_rows = data.total;
      this.instrument_collection = data.data;

      this.loading = false;
    },
  },
  async created() {
    const { data } = await InstrumentJigRepository.getAll();
    this.instrument_jig_collection = data.data.reduce((acc, { jig, id }) => {
      return jig
        ? [ ...acc, { name: jig.name, id }]
        : acc
    }, []);
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
.picked {
  background-color: #20a8d8;
  color: white;
}
</style>
